'use client';
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// biome-ignore-all lint: auto-generated code
// deno-lint-ignore-file

import useSWR, {type SWRConfiguration, type Key} from 'swr';
import useSWRMutation, {type SWRMutationConfiguration} from 'swr/mutation';

interface SwrConfig extends SWRConfiguration {
  /* Custom key for SWR. You don't have to worry about this as by default it's the URL. You can use standard SWR Key here if you need more flexibility. */
  key?: Key;
}
import xior, {type XiorResponse, type XiorRequestConfig, encodeParams} from 'xior';

export const http = xior.create({
  baseURL: '',
  paramsSerializer: (params: any) =>
    encodeParams(params, true, null, {
      allowDots: true,
      arrayFormat: 'repeat',
    }),
});

export const v4apicredentialsClient = {
  /**
   * @param body
   * @param organizationId
   */
  v4ApiCredentialsCreateApiCredential(
    body: CreateApiCredentialDTO,
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<ApiCredentialDTO>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials`;

    return http.request<ApiCredentialDTO>({
      url: url,
      method: 'POST',
      data: body,
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param apiCredentialId
   */
  v4ApiCredentialsDeleteApiCredential(
    organizationId: string,
    apiCredentialId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<unknown>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials/${encodeURIComponent(`${apiCredentialId}`)}`;

    return http.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param apiCredentialId
   */
  v4ApiCredentialsGetApiCredential(
    organizationId: string,
    apiCredentialId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<ApiCredentialDTO>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials/${encodeURIComponent(`${apiCredentialId}`)}`;

    return http.request<ApiCredentialDTO>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param organizationId */
  v4ApiCredentialsListApiCredentials(
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<ApiCredentialsDTO>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials`;

    return http.request<ApiCredentialsDTO>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param body
   * @param organizationId
   * @param apiCredentialId
   */
  v4ApiCredentialsPatchApiCredential(
    body: PatchApiCredentialDTO,
    organizationId: string,
    apiCredentialId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<unknown>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials/${encodeURIComponent(`${apiCredentialId}`)}`;

    return http.request<unknown>({
      url: url,
      method: 'PATCH',
      data: body,
      ...$config,
    });
  },
};

export const v4apicredentials = {
  queries: {
    /**
     * @param organizationId
     * @param apiCredentialId
     */
    useV4ApiCredentialsGetApiCredential(
      organizationId: string,
      apiCredentialId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v4apicredentials.queryKeys.v4ApiCredentialsGetApiCredential(organizationId, apiCredentialId);

      const {data, error, isLoading, mutate} = useSWR<ApiCredentialDTO>(
        cacheUrl,
        () =>
          v4apicredentialsClient
            .v4ApiCredentialsGetApiCredential(organizationId, apiCredentialId, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /** @param organizationId */
    useV4ApiCredentialsListApiCredentials(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v4apicredentials.queryKeys.v4ApiCredentialsListApiCredentials(organizationId);

      const {data, error, isLoading, mutate} = useSWR<ApiCredentialsDTO>(
        cacheUrl,
        () =>
          v4apicredentialsClient
            .v4ApiCredentialsListApiCredentials(organizationId, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {
    /**
     * @param body
     * @param organizationId
     */
    useV4ApiCredentialsCreateApiCredential(
      $config?: SWRMutationConfiguration<
        ApiCredentialDTO,
        Error,
        string,
        {body: CreateApiCredentialDTO; organizationId: string}
      >,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<ApiCredentialDTO, Error, string, {body: CreateApiCredentialDTO; organizationId: string}>(
        '/v4/organizations/*/api-credentials',
        (_key: string, {arg}: {arg: {body: CreateApiCredentialDTO; organizationId: string}}) =>
          v4apicredentialsClient
            .v4ApiCredentialsCreateApiCredential(arg.body, arg.organizationId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },

    /**
     * @param organizationId
     * @param apiCredentialId
     */
    useV4ApiCredentialsDeleteApiCredential(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string; apiCredentialId: string}>,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; apiCredentialId: string}>(
        '/v4/organizations/*/api-credentials/*',
        (_key: string, {arg}: {arg: {organizationId: string; apiCredentialId: string}}) =>
          v4apicredentialsClient
            .v4ApiCredentialsDeleteApiCredential(arg.organizationId, arg.apiCredentialId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },

    /**
     * @param body
     * @param organizationId
     * @param apiCredentialId
     */
    useV4ApiCredentialsPatchApiCredential(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: PatchApiCredentialDTO; organizationId: string; apiCredentialId: string}
      >,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {body: PatchApiCredentialDTO; organizationId: string; apiCredentialId: string}
      >(
        '/v4/organizations/*/api-credentials/*',
        (_key: string, {arg}: {arg: {body: PatchApiCredentialDTO; organizationId: string; apiCredentialId: string}}) =>
          v4apicredentialsClient
            .v4ApiCredentialsPatchApiCredential(arg.body, arg.organizationId, arg.apiCredentialId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },
  },

  queryKeys: {
    v4ApiCredentialsGetApiCredential: (organizationId: string, apiCredentialId: string) =>
      `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials/${encodeURIComponent(`${apiCredentialId}`)}`,
    v4ApiCredentialsListApiCredentials: (organizationId: string) =>
      `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials`,
  },
};
export const v5billinginvoicesClient = {
  /**
   * @param organizationId
   * @param invoiceId
   */
  v5BillingInvoicesGetInvoice(
    organizationId: string,
    invoiceId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetInvoiceResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices/${encodeURIComponent(`${invoiceId}`)}`;

    return http.request<GetInvoiceResponseV5>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param organizationId */
  v5BillingInvoicesGetInvoices(
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetInvoicesResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices`;

    return http.request<GetInvoicesResponseV5>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (productSlug, startingOn, endingBefore, groupKey)
   */
  v5BillingInvoicesGetLineItemsUsageSummary(
    organizationId: string,
    queryParams: {productSlug: ProductSlugV5; startingOn: string; endingBefore: string; groupKey: ChargeGroupKeyV5},
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<LineItemsUsageSummaryResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices/line-items-usage-summary`;

    return http.request<LineItemsUsageSummaryResponseV5>({
      url: url,
      method: 'GET',
      params: {
        productSlug: queryParams?.productSlug,
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        groupKey: queryParams?.groupKey,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (productSlug, startingOn, endingBefore, groupKey)
   */
  v5BillingInvoicesGetLineItemsUsageTotals(
    organizationId: string,
    queryParams: {productSlug: ProductSlugV5; startingOn: string; endingBefore: string; groupKey: ChargeGroupKeyV5},
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<LineItemsUsageSummaryResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices/line-items/usage-totals`;

    return http.request<LineItemsUsageSummaryResponseV5>({
      url: url,
      method: 'GET',
      params: {
        productSlug: queryParams?.productSlug,
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        groupKey: queryParams?.groupKey,
      },
      ...$config,
    });
  },
};

export const v5billinginvoices = {
  queries: {
    /**
     * @param organizationId
     * @param invoiceId
     */
    useV5BillingInvoicesGetInvoice(
      organizationId: string,
      invoiceId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v5billinginvoices.queryKeys.v5BillingInvoicesGetInvoice(organizationId, invoiceId);

      const {data, error, isLoading, mutate} = useSWR<GetInvoiceResponseV5>(
        cacheUrl,
        () =>
          v5billinginvoicesClient
            .v5BillingInvoicesGetInvoice(organizationId, invoiceId, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /** @param organizationId */
    useV5BillingInvoicesGetInvoices(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v5billinginvoices.queryKeys.v5BillingInvoicesGetInvoices(organizationId);

      const {data, error, isLoading, mutate} = useSWR<GetInvoicesResponseV5>(
        cacheUrl,
        () =>
          v5billinginvoicesClient.v5BillingInvoicesGetInvoices(organizationId, $httpConfig).then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (productSlug, startingOn, endingBefore, groupKey)
     */
    useV5BillingInvoicesGetLineItemsUsageSummary(
      organizationId: string,
      queryParams: {productSlug: ProductSlugV5; startingOn: string; endingBefore: string; groupKey: ChargeGroupKeyV5},
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v5billinginvoices.queryKeys.v5BillingInvoicesGetLineItemsUsageSummary(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<LineItemsUsageSummaryResponseV5>(
        cacheUrl,
        () =>
          v5billinginvoicesClient
            .v5BillingInvoicesGetLineItemsUsageSummary(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (productSlug, startingOn, endingBefore, groupKey)
     */
    useV5BillingInvoicesGetLineItemsUsageTotals(
      organizationId: string,
      queryParams: {productSlug: ProductSlugV5; startingOn: string; endingBefore: string; groupKey: ChargeGroupKeyV5},
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v5billinginvoices.queryKeys.v5BillingInvoicesGetLineItemsUsageTotals(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<LineItemsUsageSummaryResponseV5>(
        cacheUrl,
        () =>
          v5billinginvoicesClient
            .v5BillingInvoicesGetLineItemsUsageTotals(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {},

  queryKeys: {
    v5BillingInvoicesGetInvoice: (organizationId: string, invoiceId: string) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices/${encodeURIComponent(`${invoiceId}`)}`,
    v5BillingInvoicesGetInvoices: (organizationId: string) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices`,
    v5BillingInvoicesGetLineItemsUsageSummary: (
      organizationId: string,
      queryParams: {productSlug: ProductSlugV5; startingOn: string; endingBefore: string; groupKey: ChargeGroupKeyV5},
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices/line-items-usage-summary?${encodeParams({productSlug: queryParams?.productSlug, startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, groupKey: queryParams?.groupKey})}`,
    v5BillingInvoicesGetLineItemsUsageTotals: (
      organizationId: string,
      queryParams: {productSlug: ProductSlugV5; startingOn: string; endingBefore: string; groupKey: ChargeGroupKeyV5},
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices/line-items/usage-totals?${encodeParams({productSlug: queryParams?.productSlug, startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, groupKey: queryParams?.groupKey})}`,
  },
};
export const v5billingconsumptionClient = {
  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, recentConsumptionStartingOn, recentConsumptionEndingBefore)
   */
  v5BillingConsumptionGetCreditsSummary(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      recentConsumptionStartingOn?: string | null;
      recentConsumptionEndingBefore?: string | null;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetCreditsSummaryResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/credits-summary`;

    return http.request<GetCreditsSummaryResponseV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
        recentConsumptionStartingOn: queryParams?.recentConsumptionStartingOn,
        recentConsumptionEndingBefore: queryParams?.recentConsumptionEndingBefore,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
   */
  v5BillingConsumptionGetCumulativeConsumption(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      maxProjectionsCount?: number | null;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetCumulativeConsumptionResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/cumulative`;

    return http.request<GetCumulativeConsumptionResponseV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
        maxProjectionsCount: queryParams?.maxProjectionsCount,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, groupKey, units, valuesLimit)
   */
  v5BillingConsumptionGetProductUsageGroupBreakdown(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      groupKey: ChargeGroupKeyV5;
      units: string;
      valuesLimit: number;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<ProductUsageGroupBreakdownResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/product-usage-group-breakdown/${encodeURIComponent(`${productSlug}`)}`;

    return http.request<ProductUsageGroupBreakdownResponseV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
        groupKey: queryParams?.groupKey,
        units: queryParams?.units,
        valuesLimit: queryParams?.valuesLimit,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
   */
  v5BillingConsumptionGetProductsBreakdown(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      maxProjectionsCount?: number | null;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetProductsBreakdownResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/products-breakdown`;

    return http.request<GetProductsBreakdownResponseV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
        maxProjectionsCount: queryParams?.maxProjectionsCount,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window)
   */
  v5BillingConsumptionGetProductsConsumptionStats(
    organizationId: string,
    queryParams: {startingOn: string; endingBefore: string; window: ConsumptionWindowV5},
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetProductsConsumptionStatsV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/products-stats`;

    return http.request<GetProductsConsumptionStatsV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore)
   */
  v5BillingConsumptionSingleProductGetCreditSummaryByDimension(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: {startingOn: string; endingBefore: string},
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetProductCreditsSummaryResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/products/${encodeURIComponent(`${productSlug}`)}/credits-summary`;

    return http.request<GetProductCreditsSummaryResponseV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
   */
  v5BillingConsumptionSingleProductGetProductConsumptionBreakdown(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      maxProjectionsCount?: number | null;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetSingleProductConsumptionBreakdownResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/single-product-breakdown/${encodeURIComponent(`${productSlug}`)}`;

    return http.request<GetSingleProductConsumptionBreakdownResponseV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
        maxProjectionsCount: queryParams?.maxProjectionsCount,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, window)
   */
  v5BillingConsumptionSingleProductGetProductUsageBreakdown(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: {
      aggregationProfile?: ChargeAggregationProfileSlugV5 | null;
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetProductUsageBreakdownResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/product-usage-breakdown/${encodeURIComponent(`${productSlug}`)}`;

    return http.request<GetProductUsageBreakdownResponseV5>({
      url: url,
      method: 'GET',
      params: {
        aggregationProfile: queryParams?.aggregationProfile,
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, groupKeys, aggregationProfiles, valuesLimit)
   */
  v5BillingConsumptionSingleProductGetProductUsageTopGroups(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      groupKeys: ChargeGroupKeyV5[];
      aggregationProfiles?: ChargeAggregationProfileSlugV5[] | null;
      valuesLimit: number;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetProductUsageTopGroupsResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/product-usage-top-groups/${encodeURIComponent(`${productSlug}`)}`;

    return http.request<GetProductUsageTopGroupsResponseV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        groupKeys: queryParams?.groupKeys,
        aggregationProfiles: queryParams?.aggregationProfiles,
        valuesLimit: queryParams?.valuesLimit,
      },
      ...$config,
    });
  },
};

export const v5billingconsumption = {
  queries: {
    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, recentConsumptionStartingOn, recentConsumptionEndingBefore)
     */
    useV5BillingConsumptionGetCreditsSummary(
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        recentConsumptionStartingOn?: string | null;
        recentConsumptionEndingBefore?: string | null;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v5billingconsumption.queryKeys.v5BillingConsumptionGetCreditsSummary(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<GetCreditsSummaryResponseV5>(
        cacheUrl,
        () =>
          v5billingconsumptionClient
            .v5BillingConsumptionGetCreditsSummary(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
     */
    useV5BillingConsumptionGetCumulativeConsumption(
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v5billingconsumption.queryKeys.v5BillingConsumptionGetCumulativeConsumption(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<GetCumulativeConsumptionResponseV5>(
        cacheUrl,
        () =>
          v5billingconsumptionClient
            .v5BillingConsumptionGetCumulativeConsumption(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param productSlug
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, groupKey, units, valuesLimit)
     */
    useV5BillingConsumptionGetProductUsageGroupBreakdown(
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        groupKey: ChargeGroupKeyV5;
        units: string;
        valuesLimit: number;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ??
        v5billingconsumption.queryKeys.v5BillingConsumptionGetProductUsageGroupBreakdown(
          organizationId,
          productSlug,
          queryParams,
        );

      const {data, error, isLoading, mutate} = useSWR<ProductUsageGroupBreakdownResponseV5>(
        cacheUrl,
        () =>
          v5billingconsumptionClient
            .v5BillingConsumptionGetProductUsageGroupBreakdown(organizationId, productSlug, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
     */
    useV5BillingConsumptionGetProductsBreakdown(
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v5billingconsumption.queryKeys.v5BillingConsumptionGetProductsBreakdown(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<GetProductsBreakdownResponseV5>(
        cacheUrl,
        () =>
          v5billingconsumptionClient
            .v5BillingConsumptionGetProductsBreakdown(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window)
     */
    useV5BillingConsumptionGetProductsConsumptionStats(
      organizationId: string,
      queryParams: {startingOn: string; endingBefore: string; window: ConsumptionWindowV5},
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ??
        v5billingconsumption.queryKeys.v5BillingConsumptionGetProductsConsumptionStats(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<GetProductsConsumptionStatsV5>(
        cacheUrl,
        () =>
          v5billingconsumptionClient
            .v5BillingConsumptionGetProductsConsumptionStats(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param productSlug
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore)
     */
    useV5BillingConsumptionSingleProductGetCreditSummaryByDimension(
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {startingOn: string; endingBefore: string},
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ??
        v5billingconsumption.queryKeys.v5BillingConsumptionSingleProductGetCreditSummaryByDimension(
          organizationId,
          productSlug,
          queryParams,
        );

      const {data, error, isLoading, mutate} = useSWR<GetProductCreditsSummaryResponseV5>(
        cacheUrl,
        () =>
          v5billingconsumptionClient
            .v5BillingConsumptionSingleProductGetCreditSummaryByDimension(
              organizationId,
              productSlug,
              queryParams,
              $httpConfig,
            )
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param productSlug
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
     */
    useV5BillingConsumptionSingleProductGetProductConsumptionBreakdown(
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ??
        v5billingconsumption.queryKeys.v5BillingConsumptionSingleProductGetProductConsumptionBreakdown(
          organizationId,
          productSlug,
          queryParams,
        );

      const {data, error, isLoading, mutate} = useSWR<GetSingleProductConsumptionBreakdownResponseV5>(
        cacheUrl,
        () =>
          v5billingconsumptionClient
            .v5BillingConsumptionSingleProductGetProductConsumptionBreakdown(
              organizationId,
              productSlug,
              queryParams,
              $httpConfig,
            )
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param productSlug
     * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, window)
     */
    useV5BillingConsumptionSingleProductGetProductUsageBreakdown(
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {
        aggregationProfile?: ChargeAggregationProfileSlugV5 | null;
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ??
        v5billingconsumption.queryKeys.v5BillingConsumptionSingleProductGetProductUsageBreakdown(
          organizationId,
          productSlug,
          queryParams,
        );

      const {data, error, isLoading, mutate} = useSWR<GetProductUsageBreakdownResponseV5>(
        cacheUrl,
        () =>
          v5billingconsumptionClient
            .v5BillingConsumptionSingleProductGetProductUsageBreakdown(
              organizationId,
              productSlug,
              queryParams,
              $httpConfig,
            )
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param productSlug
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, groupKeys, aggregationProfiles, valuesLimit)
     */
    useV5BillingConsumptionSingleProductGetProductUsageTopGroups(
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        groupKeys: ChargeGroupKeyV5[];
        aggregationProfiles?: ChargeAggregationProfileSlugV5[] | null;
        valuesLimit: number;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ??
        v5billingconsumption.queryKeys.v5BillingConsumptionSingleProductGetProductUsageTopGroups(
          organizationId,
          productSlug,
          queryParams,
        );

      const {data, error, isLoading, mutate} = useSWR<GetProductUsageTopGroupsResponseV5>(
        cacheUrl,
        () =>
          v5billingconsumptionClient
            .v5BillingConsumptionSingleProductGetProductUsageTopGroups(
              organizationId,
              productSlug,
              queryParams,
              $httpConfig,
            )
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {},

  queryKeys: {
    v5BillingConsumptionGetCreditsSummary: (
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        recentConsumptionStartingOn?: string | null;
        recentConsumptionEndingBefore?: string | null;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/credits-summary?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window, recentConsumptionStartingOn: queryParams?.recentConsumptionStartingOn, recentConsumptionEndingBefore: queryParams?.recentConsumptionEndingBefore})}`,
    v5BillingConsumptionGetCumulativeConsumption: (
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/cumulative?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window, maxProjectionsCount: queryParams?.maxProjectionsCount})}`,
    v5BillingConsumptionGetProductUsageGroupBreakdown: (
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        groupKey: ChargeGroupKeyV5;
        units: string;
        valuesLimit: number;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/product-usage-group-breakdown/${encodeURIComponent(`${productSlug}`)}?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window, groupKey: queryParams?.groupKey, units: queryParams?.units, valuesLimit: queryParams?.valuesLimit})}`,
    v5BillingConsumptionGetProductsBreakdown: (
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/products-breakdown?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window, maxProjectionsCount: queryParams?.maxProjectionsCount})}`,
    v5BillingConsumptionGetProductsConsumptionStats: (
      organizationId: string,
      queryParams: {startingOn: string; endingBefore: string; window: ConsumptionWindowV5},
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/products-stats?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window})}`,
    v5BillingConsumptionSingleProductGetCreditSummaryByDimension: (
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {startingOn: string; endingBefore: string},
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/products/${encodeURIComponent(`${productSlug}`)}/credits-summary?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore})}`,
    v5BillingConsumptionSingleProductGetProductConsumptionBreakdown: (
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/single-product-breakdown/${encodeURIComponent(`${productSlug}`)}?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window, maxProjectionsCount: queryParams?.maxProjectionsCount})}`,
    v5BillingConsumptionSingleProductGetProductUsageBreakdown: (
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {
        aggregationProfile?: ChargeAggregationProfileSlugV5 | null;
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/product-usage-breakdown/${encodeURIComponent(`${productSlug}`)}?${encodeParams({aggregationProfile: queryParams?.aggregationProfile, startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window})}`,
    v5BillingConsumptionSingleProductGetProductUsageTopGroups: (
      organizationId: string,
      productSlug: ProductSlugV5,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        groupKeys: ChargeGroupKeyV5[];
        aggregationProfiles?: ChargeAggregationProfileSlugV5[] | null;
        valuesLimit: number;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/product-usage-top-groups/${encodeURIComponent(`${productSlug}`)}?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, groupKeys: queryParams?.groupKeys, aggregationProfiles: queryParams?.aggregationProfiles, valuesLimit: queryParams?.valuesLimit})}`,
  },
};
export const v5billingcreditsClient = {
  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
   */
  v5BillingCreditsGetContractsUtilization(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      maxProjectionsCount?: number | null;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetCumulativeConsumptionResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/contracts-utilization`;

    return http.request<GetCumulativeConsumptionResponseV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
        maxProjectionsCount: queryParams?.maxProjectionsCount,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, recentConsumptionStartingOn, recentConsumptionEndingBefore)
   */
  v5BillingCreditsGetStats(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      recentConsumptionStartingOn?: string | null;
      recentConsumptionEndingBefore?: string | null;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetCreditsSummaryResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/stats`;

    return http.request<GetCreditsSummaryResponseV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
        recentConsumptionStartingOn: queryParams?.recentConsumptionStartingOn,
        recentConsumptionEndingBefore: queryParams?.recentConsumptionEndingBefore,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, window, maxProjectionsCount)
   */
  v5BillingCreditsGetTimeseries(
    organizationId: string,
    queryParams: {
      aggregationProfile: ChargeAggregationProfileSlugV5;
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      maxProjectionsCount?: number | null;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<CreditsTimeseriesResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/timeseries`;

    return http.request<CreditsTimeseriesResponseV5>({
      url: url,
      method: 'GET',
      params: {
        aggregationProfile: queryParams?.aggregationProfile,
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
        maxProjectionsCount: queryParams?.maxProjectionsCount,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore)
   */
  v5BillingCreditsGetTotals(
    organizationId: string,
    queryParams: {aggregationProfile: ChargeAggregationProfileSlugV5; startingOn: string; endingBefore: string},
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetCreditsTotalsResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/totals`;

    return http.request<GetCreditsTotalsResponseV5>({
      url: url,
      method: 'GET',
      params: {
        aggregationProfile: queryParams?.aggregationProfile,
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
      },
      ...$config,
    });
  },
};

export const v5billingcredits = {
  queries: {
    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
     */
    useV5BillingCreditsGetContractsUtilization(
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v5billingcredits.queryKeys.v5BillingCreditsGetContractsUtilization(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<GetCumulativeConsumptionResponseV5>(
        cacheUrl,
        () =>
          v5billingcreditsClient
            .v5BillingCreditsGetContractsUtilization(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, recentConsumptionStartingOn, recentConsumptionEndingBefore)
     */
    useV5BillingCreditsGetStats(
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        recentConsumptionStartingOn?: string | null;
        recentConsumptionEndingBefore?: string | null;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v5billingcredits.queryKeys.v5BillingCreditsGetStats(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<GetCreditsSummaryResponseV5>(
        cacheUrl,
        () =>
          v5billingcreditsClient
            .v5BillingCreditsGetStats(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, window, maxProjectionsCount)
     */
    useV5BillingCreditsGetTimeseries(
      organizationId: string,
      queryParams: {
        aggregationProfile: ChargeAggregationProfileSlugV5;
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v5billingcredits.queryKeys.v5BillingCreditsGetTimeseries(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<CreditsTimeseriesResponseV5>(
        cacheUrl,
        () =>
          v5billingcreditsClient
            .v5BillingCreditsGetTimeseries(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore)
     */
    useV5BillingCreditsGetTotals(
      organizationId: string,
      queryParams: {aggregationProfile: ChargeAggregationProfileSlugV5; startingOn: string; endingBefore: string},
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v5billingcredits.queryKeys.v5BillingCreditsGetTotals(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<GetCreditsTotalsResponseV5>(
        cacheUrl,
        () =>
          v5billingcreditsClient
            .v5BillingCreditsGetTotals(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {},

  queryKeys: {
    v5BillingCreditsGetContractsUtilization: (
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/contracts-utilization?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window, maxProjectionsCount: queryParams?.maxProjectionsCount})}`,
    v5BillingCreditsGetStats: (
      organizationId: string,
      queryParams: {
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        recentConsumptionStartingOn?: string | null;
        recentConsumptionEndingBefore?: string | null;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/stats?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window, recentConsumptionStartingOn: queryParams?.recentConsumptionStartingOn, recentConsumptionEndingBefore: queryParams?.recentConsumptionEndingBefore})}`,
    v5BillingCreditsGetTimeseries: (
      organizationId: string,
      queryParams: {
        aggregationProfile: ChargeAggregationProfileSlugV5;
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
        maxProjectionsCount?: number | null;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/timeseries?${encodeParams({aggregationProfile: queryParams?.aggregationProfile, startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window, maxProjectionsCount: queryParams?.maxProjectionsCount})}`,
    v5BillingCreditsGetTotals: (
      organizationId: string,
      queryParams: {aggregationProfile: ChargeAggregationProfileSlugV5; startingOn: string; endingBefore: string},
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/totals?${encodeParams({aggregationProfile: queryParams?.aggregationProfile, startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore})}`,
  },
};
export const v5billingproductsClient = {
  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window)
   */
  v5BillingProductsGetStats(
    organizationId: string,
    queryParams: {startingOn: string; endingBefore: string; window: ConsumptionWindowV5},
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetProductsConsumptionStatsV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/products/stats`;

    return http.request<GetProductsConsumptionStatsV5>({
      url: url,
      method: 'GET',
      params: {
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
      },
      ...$config,
    });
  },
};

export const v5billingproducts = {
  queries: {
    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window)
     */
    useV5BillingProductsGetStats(
      organizationId: string,
      queryParams: {startingOn: string; endingBefore: string; window: ConsumptionWindowV5},
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v5billingproducts.queryKeys.v5BillingProductsGetStats(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<GetProductsConsumptionStatsV5>(
        cacheUrl,
        () =>
          v5billingproductsClient
            .v5BillingProductsGetStats(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {},

  queryKeys: {
    v5BillingProductsGetStats: (
      organizationId: string,
      queryParams: {startingOn: string; endingBefore: string; window: ConsumptionWindowV5},
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/products/stats?${encodeParams({startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window})}`,
  },
};
export const v5billingusageClient = {
  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, window)
   */
  v5BillingUsageGetTimeseries(
    organizationId: string,
    queryParams: {
      aggregationProfile: ChargeAggregationProfileSlugV5;
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<UsageTimeseriesResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/usage/timeseries`;

    return http.request<UsageTimeseriesResponseV5>({
      url: url,
      method: 'GET',
      params: {
        aggregationProfile: queryParams?.aggregationProfile,
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        window: queryParams?.window,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, groupValuesLimit)
   */
  v5BillingUsageGetUsageTotals(
    organizationId: string,
    queryParams: {
      aggregationProfile: ChargeAggregationProfileSlugV5;
      startingOn: string;
      endingBefore: string;
      groupValuesLimit?: number | null;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<GetUsageTotalsResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/usage/totals`;

    return http.request<GetUsageTotalsResponseV5>({
      url: url,
      method: 'GET',
      params: {
        aggregationProfile: queryParams?.aggregationProfile,
        startingOn: queryParams?.startingOn,
        endingBefore: queryParams?.endingBefore,
        groupValuesLimit: queryParams?.groupValuesLimit,
      },
      ...$config,
    });
  },
};

export const v5billingusage = {
  queries: {
    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, window)
     */
    useV5BillingUsageGetTimeseries(
      organizationId: string,
      queryParams: {
        aggregationProfile: ChargeAggregationProfileSlugV5;
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v5billingusage.queryKeys.v5BillingUsageGetTimeseries(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<UsageTimeseriesResponseV5>(
        cacheUrl,
        () =>
          v5billingusageClient
            .v5BillingUsageGetTimeseries(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, groupValuesLimit)
     */
    useV5BillingUsageGetUsageTotals(
      organizationId: string,
      queryParams: {
        aggregationProfile: ChargeAggregationProfileSlugV5;
        startingOn: string;
        endingBefore: string;
        groupValuesLimit?: number | null;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v5billingusage.queryKeys.v5BillingUsageGetUsageTotals(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<GetUsageTotalsResponseV5>(
        cacheUrl,
        () =>
          v5billingusageClient
            .v5BillingUsageGetUsageTotals(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {},

  queryKeys: {
    v5BillingUsageGetTimeseries: (
      organizationId: string,
      queryParams: {
        aggregationProfile: ChargeAggregationProfileSlugV5;
        startingOn: string;
        endingBefore: string;
        window: ConsumptionWindowV5;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/usage/timeseries?${encodeParams({aggregationProfile: queryParams?.aggregationProfile, startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, window: queryParams?.window})}`,
    v5BillingUsageGetUsageTotals: (
      organizationId: string,
      queryParams: {
        aggregationProfile: ChargeAggregationProfileSlugV5;
        startingOn: string;
        endingBefore: string;
        groupValuesLimit?: number | null;
      },
    ) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/usage/totals?${encodeParams({aggregationProfile: queryParams?.aggregationProfile, startingOn: queryParams?.startingOn, endingBefore: queryParams?.endingBefore, groupValuesLimit: queryParams?.groupValuesLimit})}`,
  },
};
export const v5billingsearchsubscriptionClient = {
  /** @param organizationId */
  v5BillingSearchSubscriptionGetSearchSubscription(
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<SearchSubscriptionResponseV5>> {
    const url = `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/search-subscription`;

    return http.request<SearchSubscriptionResponseV5>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};

export const v5billingsearchsubscription = {
  queries: {
    /** @param organizationId */
    useV5BillingSearchSubscriptionGetSearchSubscription(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v5billingsearchsubscription.queryKeys.v5BillingSearchSubscriptionGetSearchSubscription(organizationId);

      const {data, error, isLoading, mutate} = useSWR<SearchSubscriptionResponseV5>(
        cacheUrl,
        () =>
          v5billingsearchsubscriptionClient
            .v5BillingSearchSubscriptionGetSearchSubscription(organizationId, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {},

  queryKeys: {
    v5BillingSearchSubscriptionGetSearchSubscription: (organizationId: string) =>
      `/v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/search-subscription`,
  },
};
export const v1entitlementsClient = {
  /** @param tierId */
  v1EntitlementsLicenseTiersGet(tierId: string, $config?: XiorRequestConfig): Promise<XiorResponse<LicenseTierV1>> {
    const url = `/v1/entitlements/license-tiers/${encodeURIComponent(`${tierId}`)}`;

    return http.request<LicenseTierV1>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  v1EntitlementsLicenseTiersList($config?: XiorRequestConfig): Promise<XiorResponse<LicenseTiersV1>> {
    const url = `/v1/entitlements/license-tiers`;

    return http.request<LicenseTiersV1>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (cursor, limit)
   */
  v1EntitlementsOrganizationsChangelogGet(
    organizationId: string,
    queryParams: {cursor?: string | null; limit: number},
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<ChangelogResponseV1>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/changelog`;

    return http.request<ChangelogResponseV1>({
      url: url,
      method: 'GET',
      params: {
        cursor: queryParams?.cursor,
        limit: queryParams?.limit,
      },
      ...$config,
    });
  },

  /** @param organizationId */
  v1EntitlementsOrganizationsGet(
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<OrganizationEntitlementV1>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}`;

    return http.request<OrganizationEntitlementV1>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param organizationId */
  v1EntitlementsOrganizationsGetCapabilities(
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<CapabilitiesResponseV1>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/capabilities`;

    return http.request<CapabilitiesResponseV1>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param body
   * @param organizationId
   */
  v1EntitlementsOrganizationsInit(
    body: InitOrganizationEntitlementRequestV1,
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<unknown>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}`;

    return http.request<unknown>({
      url: url,
      method: 'POST',
      data: body,
      ...$config,
    });
  },

  /**
   * @param body
   * @param organizationId
   */
  v1EntitlementsOrganizationsOverrideCapabilities(
    body: OverrideCapabilitiesRequestV1,
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<unknown>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/capabilities-overrides`;

    return http.request<unknown>({
      url: url,
      method: 'PUT',
      data: body,
      ...$config,
    });
  },

  /**
   * @param body
   * @param organizationId
   */
  v1EntitlementsOrganizationsUpdateTier(
    body: UpdateTierRequestV1,
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<unknown>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/license-tier`;

    return http.request<unknown>({
      url: url,
      method: 'PUT',
      data: body,
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param workspaceId
   * @param queryParams - Grouped query parameters object (cursor, limit)
   */
  v1EntitlementsOrganizationsWorkspacesChangelogGet(
    organizationId: string,
    workspaceId: string,
    queryParams: {cursor?: string | null; limit: number},
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<ChangelogResponseV1>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/changelog`;

    return http.request<ChangelogResponseV1>({
      url: url,
      method: 'GET',
      params: {
        cursor: queryParams?.cursor,
        limit: queryParams?.limit,
      },
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param workspaceId
   */
  v1EntitlementsOrganizationsWorkspacesGet(
    organizationId: string,
    workspaceId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<WorkspaceEntitlementV1>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return http.request<WorkspaceEntitlementV1>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param workspaceId
   */
  v1EntitlementsOrganizationsWorkspacesGetCapabilities(
    organizationId: string,
    workspaceId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<CapabilitiesResponseV1>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/capabilities`;

    return http.request<CapabilitiesResponseV1>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param body
   * @param organizationId
   * @param workspaceId
   */
  v1EntitlementsOrganizationsWorkspacesOverrideCapabilities(
    body: OverrideWorkspaceCapabilitiesRequestV1,
    organizationId: string,
    workspaceId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<unknown>> {
    const url = `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/capabilities-overrides`;

    return http.request<unknown>({
      url: url,
      method: 'PUT',
      data: body,
      ...$config,
    });
  },
};

export const v1entitlements = {
  queries: {
    /** @param tierId */
    useV1EntitlementsLicenseTiersGet(
      tierId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v1entitlements.queryKeys.v1EntitlementsLicenseTiersGet(tierId);

      const {data, error, isLoading, mutate} = useSWR<LicenseTierV1>(
        cacheUrl,
        () => v1entitlementsClient.v1EntitlementsLicenseTiersGet(tierId, $httpConfig).then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    useV1EntitlementsLicenseTiersList($config?: Omit<SwrConfig, 'key'> & {key?: Key}, $httpConfig?: XiorRequestConfig) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v1entitlements.queryKeys.v1EntitlementsLicenseTiersList();

      const {data, error, isLoading, mutate} = useSWR<LicenseTiersV1>(
        cacheUrl,
        () => v1entitlementsClient.v1EntitlementsLicenseTiersList($httpConfig).then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param queryParams - Grouped query parameters object (cursor, limit)
     */
    useV1EntitlementsOrganizationsChangelogGet(
      organizationId: string,
      queryParams: {cursor?: string | null; limit: number},
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v1entitlements.queryKeys.v1EntitlementsOrganizationsChangelogGet(organizationId, queryParams);

      const {data, error, isLoading, mutate} = useSWR<ChangelogResponseV1>(
        cacheUrl,
        () =>
          v1entitlementsClient
            .v1EntitlementsOrganizationsChangelogGet(organizationId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /** @param organizationId */
    useV1EntitlementsOrganizationsGet(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v1entitlements.queryKeys.v1EntitlementsOrganizationsGet(organizationId);

      const {data, error, isLoading, mutate} = useSWR<OrganizationEntitlementV1>(
        cacheUrl,
        () =>
          v1entitlementsClient.v1EntitlementsOrganizationsGet(organizationId, $httpConfig).then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /** @param organizationId */
    useV1EntitlementsOrganizationsGetCapabilities(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v1entitlements.queryKeys.v1EntitlementsOrganizationsGetCapabilities(organizationId);

      const {data, error, isLoading, mutate} = useSWR<CapabilitiesResponseV1>(
        cacheUrl,
        () =>
          v1entitlementsClient
            .v1EntitlementsOrganizationsGetCapabilities(organizationId, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param workspaceId
     * @param queryParams - Grouped query parameters object (cursor, limit)
     */
    useV1EntitlementsOrganizationsWorkspacesChangelogGet(
      organizationId: string,
      workspaceId: string,
      queryParams: {cursor?: string | null; limit: number},
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ??
        v1entitlements.queryKeys.v1EntitlementsOrganizationsWorkspacesChangelogGet(
          organizationId,
          workspaceId,
          queryParams,
        );

      const {data, error, isLoading, mutate} = useSWR<ChangelogResponseV1>(
        cacheUrl,
        () =>
          v1entitlementsClient
            .v1EntitlementsOrganizationsWorkspacesChangelogGet(organizationId, workspaceId, queryParams, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param workspaceId
     */
    useV1EntitlementsOrganizationsWorkspacesGet(
      organizationId: string,
      workspaceId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ?? v1entitlements.queryKeys.v1EntitlementsOrganizationsWorkspacesGet(organizationId, workspaceId);

      const {data, error, isLoading, mutate} = useSWR<WorkspaceEntitlementV1>(
        cacheUrl,
        () =>
          v1entitlementsClient
            .v1EntitlementsOrganizationsWorkspacesGet(organizationId, workspaceId, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /**
     * @param organizationId
     * @param workspaceId
     */
    useV1EntitlementsOrganizationsWorkspacesGetCapabilities(
      organizationId: string,
      workspaceId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl =
        key ??
        v1entitlements.queryKeys.v1EntitlementsOrganizationsWorkspacesGetCapabilities(organizationId, workspaceId);

      const {data, error, isLoading, mutate} = useSWR<CapabilitiesResponseV1>(
        cacheUrl,
        () =>
          v1entitlementsClient
            .v1EntitlementsOrganizationsWorkspacesGetCapabilities(organizationId, workspaceId, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {
    /**
     * @param body
     * @param organizationId
     */
    useV1EntitlementsOrganizationsInit(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: InitOrganizationEntitlementRequestV1; organizationId: string}
      >,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {body: InitOrganizationEntitlementRequestV1; organizationId: string}
      >(
        '/v1/entitlements/organizations/*',
        (_key: string, {arg}: {arg: {body: InitOrganizationEntitlementRequestV1; organizationId: string}}) =>
          v1entitlementsClient
            .v1EntitlementsOrganizationsInit(arg.body, arg.organizationId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },

    /**
     * @param body
     * @param organizationId
     */
    useV1EntitlementsOrganizationsOverrideCapabilities(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: OverrideCapabilitiesRequestV1; organizationId: string}
      >,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<unknown, Error, string, {body: OverrideCapabilitiesRequestV1; organizationId: string}>(
        '/v1/entitlements/organizations/*/capabilities-overrides',
        (_key: string, {arg}: {arg: {body: OverrideCapabilitiesRequestV1; organizationId: string}}) =>
          v1entitlementsClient
            .v1EntitlementsOrganizationsOverrideCapabilities(arg.body, arg.organizationId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },

    /**
     * @param body
     * @param organizationId
     */
    useV1EntitlementsOrganizationsUpdateTier(
      $config?: SWRMutationConfiguration<unknown, Error, string, {body: UpdateTierRequestV1; organizationId: string}>,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<unknown, Error, string, {body: UpdateTierRequestV1; organizationId: string}>(
        '/v1/entitlements/organizations/*/license-tier',
        (_key: string, {arg}: {arg: {body: UpdateTierRequestV1; organizationId: string}}) =>
          v1entitlementsClient
            .v1EntitlementsOrganizationsUpdateTier(arg.body, arg.organizationId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },

    /**
     * @param body
     * @param organizationId
     * @param workspaceId
     */
    useV1EntitlementsOrganizationsWorkspacesOverrideCapabilities(
      $config?: SWRMutationConfiguration<
        unknown,
        Error,
        string,
        {body: OverrideWorkspaceCapabilitiesRequestV1; organizationId: string; workspaceId: string}
      >,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<
        unknown,
        Error,
        string,
        {body: OverrideWorkspaceCapabilitiesRequestV1; organizationId: string; workspaceId: string}
      >(
        '/v1/entitlements/organizations/*/workspaces/*/capabilities-overrides',
        (
          _key: string,
          {arg}: {arg: {body: OverrideWorkspaceCapabilitiesRequestV1; organizationId: string; workspaceId: string}},
        ) =>
          v1entitlementsClient
            .v1EntitlementsOrganizationsWorkspacesOverrideCapabilities(
              arg.body,
              arg.organizationId,
              arg.workspaceId,
              $httpConfig,
            )
            .then((resp) => resp.data),
        $config,
      );
    },
  },

  queryKeys: {
    v1EntitlementsLicenseTiersGet: (tierId: string) =>
      `/v1/entitlements/license-tiers/${encodeURIComponent(`${tierId}`)}`,
    v1EntitlementsLicenseTiersList: () => `/v1/entitlements/license-tiers`,
    v1EntitlementsOrganizationsChangelogGet: (
      organizationId: string,
      queryParams: {cursor?: string | null; limit: number},
    ) =>
      `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/changelog?${encodeParams({cursor: queryParams?.cursor, limit: queryParams?.limit})}`,
    v1EntitlementsOrganizationsGet: (organizationId: string) =>
      `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}`,
    v1EntitlementsOrganizationsGetCapabilities: (organizationId: string) =>
      `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/capabilities`,
    v1EntitlementsOrganizationsWorkspacesChangelogGet: (
      organizationId: string,
      workspaceId: string,
      queryParams: {cursor?: string | null; limit: number},
    ) =>
      `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/changelog?${encodeParams({cursor: queryParams?.cursor, limit: queryParams?.limit})}`,
    v1EntitlementsOrganizationsWorkspacesGet: (organizationId: string, workspaceId: string) =>
      `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`,
    v1EntitlementsOrganizationsWorkspacesGetCapabilities: (organizationId: string, workspaceId: string) =>
      `/v1/entitlements/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/capabilities`,
  },
};
export const v1iamClient = {
  /** @param body */
  v1IamCheckPermission(
    body: CheckPermissionRequestDTO,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<CheckPermissionResponseDTO>> {
    const url = `/v1/authz/permissions/check`;

    return http.request<CheckPermissionResponseDTO>({
      url: url,
      method: 'POST',
      data: body,
      ...$config,
    });
  },
};

export const v1iam = {
  queries: {},

  mutations: {
    /** @param body */
    useV1IamCheckPermission(
      $config?: SWRMutationConfiguration<CheckPermissionResponseDTO, Error, string, {body: CheckPermissionRequestDTO}>,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<CheckPermissionResponseDTO, Error, string, {body: CheckPermissionRequestDTO}>(
        '/v1/authz/permissions/check',
        (_key: string, {arg}: {arg: {body: CheckPermissionRequestDTO}}) =>
          v1iamClient.v1IamCheckPermission(arg.body, $httpConfig).then((resp) => resp.data),
        $config,
      );
    },
  },

  queryKeys: {},
};
export const v1notificationsClient = {
  /** @param jobId - Job ID to archive */
  notificationsArchiveJob(jobId: string, $config?: XiorRequestConfig): Promise<XiorResponse<unknown>> {
    const url = `/v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}/archive`;

    return http.request<unknown>({
      url: url,
      method: 'PATCH',
      ...$config,
    });
  },

  /** @param jobId */
  notificationsCancelScheduledJob(jobId: string, $config?: XiorRequestConfig): Promise<XiorResponse<unknown>> {
    const url = `/v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}/cancel`;

    return http.request<unknown>({
      url: url,
      method: 'POST',
      ...$config,
    });
  },

  /** @param jobId */
  notificationsDeleteJob(jobId: string, $config?: XiorRequestConfig): Promise<XiorResponse<unknown>> {
    const url = `/v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}`;

    return http.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /** @param jobId - Job ID to execute */
  notificationsExecuteJob(
    jobId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<ExecuteNotificationResponseDTO>> {
    const url = `/v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}/execute`;

    return http.request<ExecuteNotificationResponseDTO>({
      url: url,
      method: 'POST',
      ...$config,
    });
  },

  /** @param jobId */
  notificationsGetJob(jobId: string, $config?: XiorRequestConfig): Promise<XiorResponse<NotificationJobResponseDTO>> {
    const url = `/v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}`;

    return http.request<NotificationJobResponseDTO>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  notificationsGetTemplates($config?: XiorRequestConfig): Promise<XiorResponse<GetTemplatesResponseDTO>> {
    const url = `/v1/notifications/templates`;

    return http.request<GetTemplatesResponseDTO>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param queryParams - Grouped query parameters object (limit, cursor, sortBy, sortOrder, name, status, templateId, channel, brandId, startDate, endDate, includeArchived) */
  notificationsListJobs(
    queryParams: {
      limit: number;
      cursor?: string | null;
      sortBy?: 'createdAt' | 'sendDate' | null;
      sortOrder?: 'asc' | 'desc' | null;
      name?: string | null;
      status?: string | null;
      templateId?: string | null;
      channel?: string | null;
      brandId?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      includeArchived?: boolean | null;
    },
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<ListJobsResponseDTO>> {
    const url = `/v1/notifications/jobs`;

    return http.request<ListJobsResponseDTO>({
      url: url,
      method: 'GET',
      params: {
        limit: queryParams?.limit,
        cursor: queryParams?.cursor,
        sortBy: queryParams?.sortBy,
        sortOrder: queryParams?.sortOrder,
        name: queryParams?.name,
        status: queryParams?.status,
        templateId: queryParams?.templateId,
        channel: queryParams?.channel,
        brandId: queryParams?.brandId,
        startDate: queryParams?.startDate,
        endDate: queryParams?.endDate,
        includeArchived: queryParams?.includeArchived,
      },
      ...$config,
    });
  },

  /** @param body */
  notificationsScheduleNotification(
    body: ScheduleNotificationRequestDTO,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<ScheduleNotificationResponseDTO>> {
    const url = `/v1/notifications/schedule`;

    return http.request<ScheduleNotificationResponseDTO>({
      url: url,
      method: 'POST',
      data: body,
      ...$config,
    });
  },

  /** @param body */
  notificationsSendNotification(
    body: SendNotificationRequestDTO,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<SendNotificationResponseDTO>> {
    const url = `/v1/notifications/send`;

    return http.request<SendNotificationResponseDTO>({
      url: url,
      method: 'POST',
      data: body,
      ...$config,
    });
  },
};

export const v1notifications = {
  queries: {
    /** @param jobId */
    useNotificationsGetJob(
      jobId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v1notifications.queryKeys.notificationsGetJob(jobId);

      const {data, error, isLoading, mutate} = useSWR<NotificationJobResponseDTO>(
        cacheUrl,
        () => v1notificationsClient.notificationsGetJob(jobId, $httpConfig).then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    useNotificationsGetTemplates($config?: Omit<SwrConfig, 'key'> & {key?: Key}, $httpConfig?: XiorRequestConfig) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v1notifications.queryKeys.notificationsGetTemplates();

      const {data, error, isLoading, mutate} = useSWR<GetTemplatesResponseDTO>(
        cacheUrl,
        () => v1notificationsClient.notificationsGetTemplates($httpConfig).then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /** @param queryParams - Grouped query parameters object (limit, cursor, sortBy, sortOrder, name, status, templateId, channel, brandId, startDate, endDate, includeArchived) */
    useNotificationsListJobs(
      queryParams: {
        limit: number;
        cursor?: string | null;
        sortBy?: 'createdAt' | 'sendDate' | null;
        sortOrder?: 'asc' | 'desc' | null;
        name?: string | null;
        status?: string | null;
        templateId?: string | null;
        channel?: string | null;
        brandId?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        includeArchived?: boolean | null;
      },
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v1notifications.queryKeys.notificationsListJobs(queryParams);

      const {data, error, isLoading, mutate} = useSWR<ListJobsResponseDTO>(
        cacheUrl,
        () => v1notificationsClient.notificationsListJobs(queryParams, $httpConfig).then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {
    /** @param jobId - Job ID to archive */
    useNotificationsArchiveJob(
      $config?: SWRMutationConfiguration<unknown, Error, string, {jobId: string}>,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<unknown, Error, string, {jobId: string}>(
        '/v1/notifications/jobs/*/archive',
        (_key: string, {arg}: {arg: {jobId: string}}) =>
          v1notificationsClient.notificationsArchiveJob(arg.jobId, $httpConfig).then((resp) => resp.data),
        $config,
      );
    },

    /** @param jobId */
    useNotificationsCancelScheduledJob(
      $config?: SWRMutationConfiguration<unknown, Error, string, {jobId: string}>,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<unknown, Error, string, {jobId: string}>(
        '/v1/notifications/jobs/*/cancel',
        (_key: string, {arg}: {arg: {jobId: string}}) =>
          v1notificationsClient.notificationsCancelScheduledJob(arg.jobId, $httpConfig).then((resp) => resp.data),
        $config,
      );
    },

    /** @param jobId */
    useNotificationsDeleteJob(
      $config?: SWRMutationConfiguration<unknown, Error, string, {jobId: string}>,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<unknown, Error, string, {jobId: string}>(
        '/v1/notifications/jobs/*',
        (_key: string, {arg}: {arg: {jobId: string}}) =>
          v1notificationsClient.notificationsDeleteJob(arg.jobId, $httpConfig).then((resp) => resp.data),
        $config,
      );
    },

    /** @param jobId - Job ID to execute */
    useNotificationsExecuteJob(
      $config?: SWRMutationConfiguration<ExecuteNotificationResponseDTO, Error, string, {jobId: string}>,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<ExecuteNotificationResponseDTO, Error, string, {jobId: string}>(
        '/v1/notifications/jobs/*/execute',
        (_key: string, {arg}: {arg: {jobId: string}}) =>
          v1notificationsClient.notificationsExecuteJob(arg.jobId, $httpConfig).then((resp) => resp.data),
        $config,
      );
    },

    /** @param body */
    useNotificationsScheduleNotification(
      $config?: SWRMutationConfiguration<
        ScheduleNotificationResponseDTO,
        Error,
        string,
        {body: ScheduleNotificationRequestDTO}
      >,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<ScheduleNotificationResponseDTO, Error, string, {body: ScheduleNotificationRequestDTO}>(
        '/v1/notifications/schedule',
        (_key: string, {arg}: {arg: {body: ScheduleNotificationRequestDTO}}) =>
          v1notificationsClient.notificationsScheduleNotification(arg.body, $httpConfig).then((resp) => resp.data),
        $config,
      );
    },

    /** @param body */
    useNotificationsSendNotification(
      $config?: SWRMutationConfiguration<
        SendNotificationResponseDTO,
        Error,
        string,
        {body: SendNotificationRequestDTO}
      >,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<SendNotificationResponseDTO, Error, string, {body: SendNotificationRequestDTO}>(
        '/v1/notifications/send',
        (_key: string, {arg}: {arg: {body: SendNotificationRequestDTO}}) =>
          v1notificationsClient.notificationsSendNotification(arg.body, $httpConfig).then((resp) => resp.data),
        $config,
      );
    },
  },

  queryKeys: {
    notificationsGetJob: (jobId: string) => `/v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}`,
    notificationsGetTemplates: () => `/v1/notifications/templates`,
    notificationsListJobs: (queryParams: {
      limit: number;
      cursor?: string | null;
      sortBy?: 'createdAt' | 'sendDate' | null;
      sortOrder?: 'asc' | 'desc' | null;
      name?: string | null;
      status?: string | null;
      templateId?: string | null;
      channel?: string | null;
      brandId?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      includeArchived?: boolean | null;
    }) =>
      `/v1/notifications/jobs?${encodeParams({limit: queryParams?.limit, cursor: queryParams?.cursor, sortBy: queryParams?.sortBy, sortOrder: queryParams?.sortOrder, name: queryParams?.name, status: queryParams?.status, templateId: queryParams?.templateId, channel: queryParams?.channel, brandId: queryParams?.brandId, startDate: queryParams?.startDate, endDate: queryParams?.endDate, includeArchived: queryParams?.includeArchived})}`,
  },
};
export const v4sandboxesClient = {
  /** @param courseId */
  v4SandboxesAssignSandboxWorkspaceToUser(
    courseId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<AssignedSandboxAssignmentDTO>> {
    const url = `/v4/sandboxes/${encodeURIComponent(`${courseId}`)}`;

    return http.request<AssignedSandboxAssignmentDTO>({
      url: url,
      method: 'POST',
      ...$config,
    });
  },

  v4SandboxesGetAssignments($config?: XiorRequestConfig): Promise<XiorResponse<SandboxAssignmentDTO[]>> {
    const url = `/v4/sandboxes`;

    return http.request<SandboxAssignmentDTO[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};

export const v4sandboxes = {
  queries: {
    useV4SandboxesGetAssignments($config?: Omit<SwrConfig, 'key'> & {key?: Key}, $httpConfig?: XiorRequestConfig) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v4sandboxes.queryKeys.v4SandboxesGetAssignments();

      const {data, error, isLoading, mutate} = useSWR<SandboxAssignmentDTO[]>(
        cacheUrl,
        () => v4sandboxesClient.v4SandboxesGetAssignments($httpConfig).then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {
    /** @param courseId */
    useV4SandboxesAssignSandboxWorkspaceToUser(
      $config?: SWRMutationConfiguration<AssignedSandboxAssignmentDTO, Error, string, {courseId: string}>,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<AssignedSandboxAssignmentDTO, Error, string, {courseId: string}>(
        '/v4/sandboxes/*',
        (_key: string, {arg}: {arg: {courseId: string}}) =>
          v4sandboxesClient
            .v4SandboxesAssignSandboxWorkspaceToUser(arg.courseId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },
  },

  queryKeys: {
    v4SandboxesGetAssignments: () => `/v4/sandboxes`,
  },
};
export const v4workspacesClient = {
  /**
   * @param body
   * @param organizationId
   */
  v4WorkspacesCreateWorkspace(
    body: CreateWorkspaceDTO,
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<WorkspaceDTO>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces`;

    return http.request<WorkspaceDTO>({
      url: url,
      method: 'POST',
      data: body,
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param workspaceId
   */
  v4WorkspacesDeleteWorkspace(
    organizationId: string,
    workspaceId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<unknown>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return http.request<unknown>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param workspaceId
   */
  v4WorkspacesGetWorkspace(
    organizationId: string,
    workspaceId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<WorkspaceDTO>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return http.request<WorkspaceDTO>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /** @param organizationId */
  v4WorkspacesListWorkspaces(
    organizationId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<WorkspacesDTO>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces`;

    return http.request<WorkspacesDTO>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },

  /**
   * @param body
   * @param organizationId
   * @param workspaceId
   */
  v4WorkspacesPatchWorkspace(
    body: PatchWorkspaceDTO,
    organizationId: string,
    workspaceId: string,
    $config?: XiorRequestConfig,
  ): Promise<XiorResponse<WorkspaceDTO>> {
    const url = `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return http.request<WorkspaceDTO>({
      url: url,
      method: 'PATCH',
      data: body,
      ...$config,
    });
  },
};

export const v4workspaces = {
  queries: {
    /**
     * @param organizationId
     * @param workspaceId
     */
    useV4WorkspacesGetWorkspace(
      organizationId: string,
      workspaceId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v4workspaces.queryKeys.v4WorkspacesGetWorkspace(organizationId, workspaceId);

      const {data, error, isLoading, mutate} = useSWR<WorkspaceDTO>(
        cacheUrl,
        () =>
          v4workspacesClient
            .v4WorkspacesGetWorkspace(organizationId, workspaceId, $httpConfig)
            .then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },

    /** @param organizationId */
    useV4WorkspacesListWorkspaces(
      organizationId: string,
      $config?: Omit<SwrConfig, 'key'> & {key?: Key},
      $httpConfig?: XiorRequestConfig,
    ) {
      const {key, ...config} = $config || {};
      const cacheUrl = key ?? v4workspaces.queryKeys.v4WorkspacesListWorkspaces(organizationId);

      const {data, error, isLoading, mutate} = useSWR<WorkspacesDTO>(
        cacheUrl,
        () => v4workspacesClient.v4WorkspacesListWorkspaces(organizationId, $httpConfig).then((resp) => resp.data),
        config,
      );

      return {data, isLoading, error, mutate};
    },
  },

  mutations: {
    /**
     * @param body
     * @param organizationId
     */
    useV4WorkspacesCreateWorkspace(
      $config?: SWRMutationConfiguration<
        WorkspaceDTO,
        Error,
        string,
        {body: CreateWorkspaceDTO; organizationId: string}
      >,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<WorkspaceDTO, Error, string, {body: CreateWorkspaceDTO; organizationId: string}>(
        '/v4/organizations/*/workspaces',
        (_key: string, {arg}: {arg: {body: CreateWorkspaceDTO; organizationId: string}}) =>
          v4workspacesClient
            .v4WorkspacesCreateWorkspace(arg.body, arg.organizationId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },

    /**
     * @param organizationId
     * @param workspaceId
     */
    useV4WorkspacesDeleteWorkspace(
      $config?: SWRMutationConfiguration<unknown, Error, string, {organizationId: string; workspaceId: string}>,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<unknown, Error, string, {organizationId: string; workspaceId: string}>(
        '/v4/organizations/*/workspaces/*',
        (_key: string, {arg}: {arg: {organizationId: string; workspaceId: string}}) =>
          v4workspacesClient
            .v4WorkspacesDeleteWorkspace(arg.organizationId, arg.workspaceId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },

    /**
     * @param body
     * @param organizationId
     * @param workspaceId
     */
    useV4WorkspacesPatchWorkspace(
      $config?: SWRMutationConfiguration<
        WorkspaceDTO,
        Error,
        string,
        {body: PatchWorkspaceDTO; organizationId: string; workspaceId: string}
      >,
      $httpConfig?: XiorRequestConfig,
    ) {
      return useSWRMutation<
        WorkspaceDTO,
        Error,
        string,
        {body: PatchWorkspaceDTO; organizationId: string; workspaceId: string}
      >(
        '/v4/organizations/*/workspaces/*',
        (_key: string, {arg}: {arg: {body: PatchWorkspaceDTO; organizationId: string; workspaceId: string}}) =>
          v4workspacesClient
            .v4WorkspacesPatchWorkspace(arg.body, arg.organizationId, arg.workspaceId, $httpConfig)
            .then((resp) => resp.data),
        $config,
      );
    },
  },

  queryKeys: {
    v4WorkspacesGetWorkspace: (organizationId: string, workspaceId: string) =>
      `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`,
    v4WorkspacesListWorkspaces: (organizationId: string) =>
      `/v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces`,
  },
};
export type DefaultErrorDTO = {
  statusCode: number;
  message: string;
};

export type ProductRoleDTO = {
  workspaceId: string;
  product: 'edge' | 'search' | 'stream' | 'lake';
  role: 'product_admin' | 'product_editor' | 'product_reader' | 'product_user' | 'product_noaccess';
};

export type WorkspaceRoleDTO = {
  workspaceId: string;
  role: 'ws_owner' | 'ws_admin' | 'ws_user' | 'noaccess';
};

export type ApiCredentialDTO = {
  clientId: string;
  clientSecret?: string;
  name: string;
  description?: string;
  productRoles: ProductRoleDTO[];
  workspaceRoles: WorkspaceRoleDTO[];
  organizationId: string;
  createdBy: string;
  /** @format date-time */
  createdDate: string;
  lastUpdatedBy: string;
  /** @format date-time */
  lastUpdatedDate: string;
  clientAssignedName: string;
  role: 'org_owner' | 'org_admin' | 'org_iam_admin' | 'org_user' | 'billing_reader';
  enabled: boolean;
  system: boolean;
};

export type ApiCredentialsDTO = {
  items: ApiCredentialDTO[];
  count: number;
};

export type CreateApiCredentialDTO = {
  clientAssignedName: string;
  description: string;
  enabled: boolean;
  role: 'org_owner' | 'org_admin' | 'org_iam_admin' | 'org_user' | 'billing_reader';
  productRoles?: ProductRoleDTO[];
  workspaceRoles?: WorkspaceRoleDTO[];
};

export type PatchApiCredentialDTO = {
  clientAssignedName?: string;
  description?: string;
  role?: 'org_owner' | 'org_admin' | 'org_iam_admin' | 'org_user' | 'billing_reader';
  enabled?: boolean;
  productRoles?: ProductRoleDTO[];
  workspaceRoles?: WorkspaceRoleDTO[];
};

export enum InvoiceStatusV5 {
  DRAFT = 'DRAFT',
  FINALIZED = 'FINALIZED',
  VOID = 'VOID',
}

export enum InvoiceProductSlugV5 {
  Stream = 'stream',
  Search = 'search',
  Edge = 'edge',
  Lake = 'lake',
  Lakehouse = 'lakehouse',
  LocalSearch = 'local-search',
  FederatedEngine = 'federated-engine',
  LakeByos = 'lake-byos',
  Guard = 'guard',
  Infrastructure = 'infrastructure',
  Insights = 'insights',
  Other = 'other',
}

export enum ChargeGroupKeyV5 {
  Workspace = 'workspace',
  Workergroup = 'workergroup',
  DeploymentId = 'deployment_id',
  ClusterId = 'cluster_id',
  Other = 'other',
}

export type ChargeGroupV5 = {
  key: ChargeGroupKeyV5;
  value: string;
};

export type LineItemV5 = {
  name: string;
  quantity: number;
  units?: string;
  credits: number;
  groups: ChargeGroupV5[];
};

export type InvoiceProductV5 = {
  slug: InvoiceProductSlugV5;
  parentProductSlug?: string;
  name: string;
  totalCredits: number;
  lineItems: LineItemV5[];
};

export type InvoiceV5 = {
  id: string;
  /** @format date-time */
  fromDate: string;
  /** @format date-time */
  toDate: string;
  totalCredits: number;
  status: InvoiceStatusV5;
  products: InvoiceProductV5[];
};

export type GetInvoicesResponseV5 = {
  items: InvoiceV5[];
  count: number;
};

export enum ProductSlugV5 {
  Stream = 'stream',
  Search = 'search',
  Edge = 'edge',
  Lake = 'lake',
  Lakehouse = 'lakehouse',
  LocalSearch = 'local-search',
  FederatedEngine = 'federated-engine',
  LakeByos = 'lake-byos',
  Guard = 'guard',
  Infrastructure = 'infrastructure',
  Insights = 'insights',
  Other = 'other',
}

export type LineItemsUsageSummaryPerUnitV5 = {
  /** The unit of measurement */
  units?: string;
  /** The aggregated quantity for the unit */
  quantity: number;
};

export type LineItemsUsageSummaryItemV5 = {
  /** The name of the item */
  name: string;
  /** The value of the group key */
  groupValue: string;
  /** Array of aggregated quantities per unit */
  perUnit: LineItemsUsageSummaryPerUnitV5[];
};

export type LineItemsUsageSummaryResponseV5 = {
  /** Array of aggregated line item usage summaries */
  items: LineItemsUsageSummaryItemV5[];
};

export type GetInvoiceResponseV5 = {
  data: InvoiceV5;
};

export enum TrendDirectionV5 {
  Increasing = 'increasing',
  Decreasing = 'decreasing',
  Stable = 'stable',
}

export type TrendV5 = {
  direction: TrendDirectionV5;
  percentageChange?: number;
  extremeThresholdReached?: boolean;
};

export type CreditGrantSummaryV5 = {
  id: string;
  /** @format date-time */
  date: string;
  creditsAcquired: number;
  type: string;
};

export type ContractsSummaryV5 = {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate?: string;
};

export type CreditsSummaryV5 = {
  totalCreditsRemaining: number;
  totalCreditsUsed: number;
  totalCreditsAcquired: number;
  recentConsumption: number;
  recentConsumptionTrend?: TrendV5;
  averageConsumption: number;
  /** @format date-time */
  contractStartDate: string;
  /** @format date-time */
  contractEndDate?: string;
  grants: CreditGrantSummaryV5[];
  contracts?: ContractsSummaryV5[];
};

export type GetCreditsSummaryResponseV5 = {
  data: CreditsSummaryV5;
};

export enum ConsumptionWindowV5 {
  Monthly = 'monthly',
  Weekly = 'weekly',
  Daily = 'daily',
  Quarterly = 'quarterly',
}

export type CreditsConsumptionItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
};

export type ContractCumulativeConsumptionV5 = {
  /** @format date-time */
  contractStartDate: string;
  /** @format date-time */
  contractEndDate?: string;
  items: CreditsConsumptionItemV5[];
};

export type CreditsConsumptionProjectionsV5 = {
  data: CreditsConsumptionItemV5[];
};

export type CumulativeConsumptionV5 = {
  contracts: ContractCumulativeConsumptionV5[];
  projections?: CreditsConsumptionProjectionsV5;
};

export type GetCumulativeConsumptionResponseV5 = {
  data: CumulativeConsumptionV5;
};

export type ProductCreditsConsumptionItemV5 = {
  slug: string;
  credits: number;
};

export type ProductsBreakdownItemV5 = {
  /** @format date-time */
  date: string;
  products: ProductCreditsConsumptionItemV5[];
};

export type ProjectedProductsBreakdownItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
};

export type ProductsBreakdownProjectionsV5 = {
  data: ProjectedProductsBreakdownItemV5[];
};

export type GetProductsBreakdownResponseV5 = {
  items: ProductsBreakdownItemV5[];
  count: number;
  projections?: ProductsBreakdownProjectionsV5;
};

export type ProductUnitStatsV5 = {
  averageQuantity: number;
  recentQuantity: number;
  totalQuantity: number;
  totalCredits: number;
  recentCredits: number;
  averageCredits: number;
  units?: string;
  trend?: TrendV5;
};

export type SingleProductConsumptionStatsV5 = {
  slug: ProductSlugV5;
  totalCredits: number;
  perUnit: ProductUnitStatsV5[];
};

export type GetProductsConsumptionStatsV5 = {
  items: SingleProductConsumptionStatsV5[];
  count: number;
};

export type ProductCreditsSummaryItemV5 = {
  /** Human friendly name of the dimension */
  dimension: string;
  /** Total credits consumed for the dimension. */
  credits: number;
};

export type GetProductCreditsSummaryResponseV5 = {
  items: ProductCreditsSummaryItemV5[];
  /** Total number of items. */
  count: number;
};

export type SingleProductConsumptionBreakdownPerUnitItemV5 = {
  quantity: number;
  credits: number;
  units?: string;
};

export type SingleProductConsumptionBreakdownItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
  perUnit: SingleProductConsumptionBreakdownPerUnitItemV5[];
};

export type SingleProductConsumptionBreakdownProjectedItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
};

export type SingleProductConsumptionBreakdownProjectionsV5 = {
  data: SingleProductConsumptionBreakdownProjectedItemV5[];
};

export type GetSingleProductConsumptionBreakdownResponseV5 = {
  items: SingleProductConsumptionBreakdownItemV5[];
  count: number;
  projections?: SingleProductConsumptionBreakdownProjectionsV5;
};

export enum ChargeAggregationProfileSlugV5 {
  TopOtherTypes = 'top-other-types',
  StreamAllEnvironments = 'stream-all-environments',
  StreamWorkergroups = 'stream-workergroups',
  StreamPerWorkspaceUsage = 'stream-per-workspace-usage',
  EdgeDroppedBytesVsTotalIngest = 'edge-dropped-bytes-vs-total-ingest',
  EdgePerWorkspaceUsage = 'edge-per-workspace-usage',
  SearchPerWorkspaceUsage = 'search-per-workspace-usage',
  LakePerWorkspaceUsage = 'lake-per-workspace-usage',
  LakeUsage = 'lake-usage',
  LakeCredits = 'lake-credits',
  Lakehouse = 'lakehouse',
  LocalSearch = 'local-search',
  InfrastructurePerWorkspaceUsage = 'infrastructure-per-workspace-usage',
  GuardPerWorkspaceUsage = 'guard-per-workspace-usage',
  AllChargesByProduct = 'all-charges-by-product',
  StreamAllCharges = 'stream-all-charges',
  SearchAllCharges = 'search-all-charges',
  EdgeAllCharges = 'edge-all-charges',
  LakeAllCharges = 'lake-all-charges',
  LakehouseAllCharges = 'lakehouse-all-charges',
  LocalSearchAllCharges = 'local-search-all-charges',
  FederatedEngineAllCharges = 'federated-engine-all-charges',
  LakeByosAllCharges = 'lake-byos-all-charges',
  GuardAllCharges = 'guard-all-charges',
  InfrastructureAllCharges = 'infrastructure-all-charges',
  InsightsAllCharges = 'insights-all-charges',
  OtherAllCharges = 'other-all-charges',
}

export type ProductUsageBreakdownItemValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Quantity for this dimension value */
  quantity: number;
  /** Units corresponding to the quantity (optional) */
  units?: string;
};

export type ProductUsageBreakdownItemV5 = {
  /**
   * Date of the usage measurement
   * @format date-time
   */
  date: string;
  /** Values corresponds to the requested profile dimensions */
  values: ProductUsageBreakdownItemValueV5[];
};

export type GetProductUsageBreakdownResponseV5 = {
  /** List of usage breakdown items */
  items: ProductUsageBreakdownItemV5[];
  /** Number of items */
  count: number;
};

export type ProductUsageTopGroupItemPerUnitValueV5 = {
  value: string;
  quantity: number;
  trend?: TrendV5;
};

export type ProductUsageTopGroupItemPerUnitV5 = {
  units?: string;
  values: ProductUsageTopGroupItemPerUnitValueV5[];
};

export type ProductUsageTopGroupItemV5 = {
  key: string;
  perUnit: ProductUsageTopGroupItemPerUnitV5[];
};

export type GetProductUsageTopGroupsResponseV5 = {
  items: ProductUsageTopGroupItemV5[];
  count: number;
};

export type ProductUsageGroupBreakdownItemValueV5 = {
  value: string;
  quantity: number;
};

export type ProductUsageGroupBreakdownItemV5 = {
  /** @format date-time */
  date: string;
  values: ProductUsageGroupBreakdownItemValueV5[];
};

export type ProductUsageGroupBreakdownResponseV5 = {
  items: ProductUsageGroupBreakdownItemV5[];
  count: number;
};

export type CreditsTimeseriesDimensionValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Credits for this dimension */
  credits: number;
};

export type CreditsTimeseriesItemV5 = {
  /** @format date-time */
  date: string;
  /** Total credits consumed */
  credits: number;
  dimensions: CreditsTimeseriesDimensionValueV5[];
};

export type CreditsTimeseriesProjectedItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
};

export type CreditsTimeseriesProjectionsV5 = {
  data: CreditsTimeseriesProjectedItemV5[];
};

export type CreditsTimeseriesResponseV5 = {
  items: CreditsTimeseriesItemV5[];
  count: number;
  projections?: CreditsTimeseriesProjectionsV5;
};

export type CreditsTotalsDimensionValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Total credits consumed in the given interval for this dimension */
  credits: number;
};

export type CreditsTotalsItemV5 = {
  /** Total credits consumed across all dimensions */
  credits: number;
  dimensions: CreditsTotalsDimensionValueV5[];
};

export type GetCreditsTotalsResponseV5 = {
  totals: CreditsTotalsItemV5;
};

export type UsageTimeseriesDimensionValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Raw usage quantity for this dimension */
  value: number;
  /** Display units (e.g. "GB", "CPU Hours") */
  units?: string;
};

export type UsageTimeseriesItemV5 = {
  /** @format date-time */
  date: string;
  dimensions: UsageTimeseriesDimensionValueV5[];
};

export type UsageTimeseriesResponseV5 = {
  items: UsageTimeseriesItemV5[];
  count: number;
};

export type UsageTotalsGroupValueV5 = {
  /** Group value name (e.g. workspace name) */
  name: string;
  /** Usage quantity for this group */
  value: number;
  /** Trend analysis for the group */
  trend?: TrendV5;
};

export type UsageTotalsDimensionValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Total usage quantity (omitted when groupValues is present) */
  value?: number;
  /** Display units (e.g. "GB", "CPU Hours") */
  units?: string;
  /** Trend analysis for the dimension (only for charge-based profiles) */
  trend?: TrendV5;
  /** Group-level breakdown within this dimension */
  groupValues?: UsageTotalsGroupValueV5[];
};

export type GetUsageTotalsResponseV5 = {
  /** Dimensional breakdown of usage, ordered by value (biggest first) */
  dimensions: UsageTotalsDimensionValueV5[];
};

export type SearchSubscriptionResponseV5 = {
  isEnabled: boolean;
  /** @format date-time */
  contractEnd?: string;
};

export type EgressTypeNATCapabilityV1 = {
  /** Whether the capability is enabled */
  enabled: boolean;
};

export type StandardCapabilityV1 = {
  /** Whether the capability is enabled */
  enabled: boolean;
};

export type CapabilitiesV1 = {
  /** Egress type NAT capability */
  'cloud.network.egressTypeNAT'?: EgressTypeNATCapabilityV1;
  /** SMTP configuration capability */
  'cloud.notifications.smtpConfig'?: StandardCapabilityV1;
  /** Teams capability */
  'cloud.auth.teams'?: StandardCapabilityV1;
  /** Workspace provisioning capability */
  'cloud.workspace.provisioning'?: StandardCapabilityV1;
  /** Audit logs capability */
  'cloud.audit.logs'?: StandardCapabilityV1;
  /** Multi-region workspaces capability */
  'cloud.workspace.multiRegion'?: StandardCapabilityV1;
  /** Release channels capability */
  'cloud.workspace.releaseChannels'?: StandardCapabilityV1;
};

export type LicenseTierV1 = {
  /** License tier identifier */
  tierId: string;
  /** Revision number of the tier capabilities */
  revision: number;
  /** Capabilities configuration for this tier */
  capabilities: CapabilitiesV1;
};

export type LicenseTiersV1 = {
  /** List of all available license tiers */
  items: LicenseTierV1[];
};

export type InitOrganizationEntitlementRequestV1 = {
  /** License tier identifier */
  tierId: string;
};

export type OrganizationEntitlementV1 = {
  /** License tier identifier */
  tierId: string;
  /** Revision number of the tier capabilities */
  tierRevision: number;
  /** Organization-level capability overrides */
  capabilities?: CapabilitiesV1;
  /**
   * Timestamp when entitlements were initialized
   * @format date-time
   */
  createdAt: string;
  /**
   * Timestamp when entitlements were last updated
   * @format date-time
   */
  updatedAt: string;
};

export type UpdateTierRequestV1 = {
  /** New license tier identifier */
  tierId: string;
  /** Optional user comment for changelog */
  userComment?: string;
};

export type OverrideCapabilitiesRequestV1 = {
  /** Organization-level capability overrides. Partial overrides are supported - only specified capabilities will override tier defaults. Empty object {} removes all overrides. */
  capabilities: CapabilitiesV1;
  /** Optional user comment for audit trail */
  userComment?: string;
};

export type WorkspaceEntitlementV1 = {
  /** Workspace identifier */
  workspaceId: string;
  /** Workspace-level capability overrides */
  capabilities: CapabilitiesV1;
  /**
   * Timestamp when the workspace entitlement was created
   * @format date-time
   */
  createdAt: string;
  /**
   * Timestamp when entitlements were last updated
   * @format date-time
   */
  updatedAt: string;
  /** Revision of the item. Used for optimistic locking. */
  itemRevision: string;
};

export type OverrideWorkspaceCapabilitiesRequestV1 = {
  /** Workspace-level capability overrides. Partial overrides are supported - only specified capabilities will override org defaults. Empty object {} removes all overrides. */
  capabilities: CapabilitiesV1;
  /** Optional user comment for changelog */
  userComment?: string;
};

export type EntitlementChangeLogEntryV1 = {
  /** The organization ID that the change applies to */
  organizationId: string;
  /** The workspace ID that the change applies to (if overridden on workspace level) */
  workspaceId?: string;
  /** License tier identifier */
  tierId: string;
  /** Revision number of the tier capabilities */
  tierRevision: number;
  /** The old capabilities before the change */
  oldCapabilities?: CapabilitiesV1;
  /** The new capabilities after the change */
  newCapabilities?: CapabilitiesV1;
  /** The user (or other identity) who made the change */
  initiator: Record<string, unknown>;
  /** Human readable reason for the change */
  systemComment: string;
  /**
   * Timestamp when the change was made
   * @format date-time
   */
  createdAt: string;
};

export type ChangelogResponseV1 = {
  /** List of changelog entries */
  items: EntitlementChangeLogEntryV1[];
  /** Cursor token for fetching the next page of results. If not present, there are no more items. */
  nextCursor?: string;
};

export type CapabilitiesResponseV1 = {
  /** Resolved capabilities (tier defaults merged with overrides) */
  capabilities: CapabilitiesV1;
  /** Current license tier identifier (e.g. standard, enterprise, enterprise-global) */
  tierId: string;
};

export type PermissionDTO = {
  action: 'create' | 'read' | 'update' | 'delete';
  resource:
    | 'billing'
    | 'clients'
    | 'connections'
    | 'invites'
    | 'members'
    | 'teams'
    | 'workspaces'
    | 'workergroups'
    | 'smtp-configs'
    | 'organization'
    | 'organization-auth-settings'
    | 'leader'
    | 'connected-deployments';
};

export type ParentObjectDTO = {
  id: string;
  type: 'user' | 'client' | 'team' | 'system' | 'organization' | 'workspace' | 'edge' | 'lake' | 'search' | 'stream';
  parent?: ParentObjectDTO;
};

export type ObjectDTO = {
  id: string;
  type: 'user' | 'client' | 'team' | 'system' | 'organization' | 'workspace' | 'edge' | 'lake' | 'search' | 'stream';
  parent?: ParentObjectDTO;
};

export type CheckPermissionRequestDTO = {
  permission: PermissionDTO;
  object: ObjectDTO;
};

export type CheckPermissionResponseDTO = {
  /** Whether the user has the requested permission */
  allowed: boolean;
};

export type TemplateDTO = {
  /** Unique identifier for the template */
  id: string;
  /** Title of the template */
  title: string;
  /**
   * ISO 8601 date string when the template was created
   * @format date-time
   */
  createdAt: string;
  /**
   * ISO 8601 date string when the template was last updated
   * @format date-time
   */
  updatedAt: string;
};

export type GetTemplatesResponseDTO = {
  /** List of notification templates */
  items: TemplateDTO[];
};

export type SendNotificationRequestDTO = {
  /** Human-readable name for this notification job */
  name: string;
  /** Notification template ID from Courier */
  notificationTemplateId: string;
  /** Brand ID for the notification */
  brandId: string;
  /** Target for the notification */
  notificationTarget: 'allOrganizations' | 'selectedOrganizations';
  /** User type filter (required for allOrganizations target) */
  userType?: 'regular' | 'oemCrowdStrike';
  /** License type filter (required for allOrganizations target) */
  licenseType?: 'all' | 'enterprise' | 'standard';
  /** List of organization IDs to exclude from notification */
  excludedOrganizations?: string[];
  /** List of specific organization IDs to target (required for selectedOrganizations target) */
  selectedOrganizations?: string[];
  /** Release channel filter (optional, applies to both targets) */
  releaseChannelFilter?: 'all' | 'main' | 'maintenance';
  /** Template variable inputs as key-value pairs */
  templateInputs?: Record<string, unknown>;
  /**
   * Notification channel (normal or slow release)
   * @default "normal"
   */
  channel?: 'normal' | 'slowRelease';
  /**
   * Scheduled send date (if not provided, sends immediately)
   * @format date-time
   */
  sendDate?: string;
  /**
   * Send type: live for real execution, dryRun for preview only
   * @default "live"
   */
  sendType?: 'live' | 'dryRun';
};

export type SendNotificationResponseDTO = {
  /** Internal notification job ID */
  jobId: string;
  /** Courier bulk job ID when known (empty in the HTTP response; use the job detail API after processing) */
  providerJobId: string;
  /** Recipient count when known (0 in the HTTP response; use the job detail API after processing) */
  usersCount: number;
};

export type ScheduleNotificationRequestDTO = {
  /** Human-readable name for this notification job */
  name: string;
  /** Notification template ID from Courier */
  notificationTemplateId: string;
  /** Brand ID for the notification */
  brandId: string;
  /** Target for the notification */
  notificationTarget: 'allOrganizations' | 'selectedOrganizations';
  /** User type filter (required for allOrganizations target) */
  userType?: 'regular' | 'oemCrowdStrike';
  /** License type filter (required for allOrganizations target) */
  licenseType?: 'all' | 'enterprise' | 'standard';
  /** List of organization IDs to exclude from notification */
  excludedOrganizations?: string[];
  /** List of specific organization IDs to target (required for selectedOrganizations target) */
  selectedOrganizations?: string[];
  /** Release channel filter (optional, applies to both targets) */
  releaseChannelFilter?: 'all' | 'main' | 'maintenance';
  /** Template variable inputs as key-value pairs */
  templateInputs?: Record<string, unknown>;
  /**
   * Notification channel (normal or slow release)
   * @default "normal"
   */
  channel?: 'normal' | 'slowRelease';
  /**
   * Scheduled send date (required for scheduling)
   * @format date-time
   */
  sendDate: string;
  /**
   * Send type: live for real execution, dryRun for preview only
   * @default "live"
   */
  sendType?: 'live' | 'dryRun';
};

export type ScheduleNotificationResponseDTO = {
  /** Internal notification job ID */
  jobId: string;
};

export type NotificationJobUserDTO = {
  email: string;
  status: 'ADDED' | 'SENT' | 'FAILED';
  addedAt: string;
  organizationIds: string[];
};

export type NotificationJobResponseDTO = {
  jobId: string;
  name: string;
  providerJobId?: string;
  templateId: string;
  brandId: string;
  schedulingType: string;
  sendType: string;
  sendDate: string;
  status: string;
  requestData: Record<string, unknown>;
  responseData?: Record<string, unknown>;
  usersCount: number;
  organizationsCount: number;
  /** Predicted user count for scheduled jobs before execution */
  predictedUsersCount?: number;
  /** List of users with send status */
  users: NotificationJobUserDTO[];
  /** Organization IDs targeted by this job */
  organizationIds: string[];
  createdBy?: string;
  createdAt: string;
  lastUpdated: string;
};

export type ListJobsResponseDTO = {
  items: NotificationJobResponseDTO[];
  /** Cursor for next page */
  cursor?: string;
  limit: number;
};

export type ExecuteNotificationResponseDTO = {
  /** Internal notification job ID */
  jobId: string;
  /** Provider (Courier) bulk job ID */
  providerJobId: string;
  /** Number of users who received the notification */
  usersCount: number;
};

export type AssignedSandboxAssignmentDTO = {
  organizationId: string;
  workspaceId: string;
  state: 'ASSIGNED';
  userId: string;
  courseId: string;
  /** @format date-time */
  assignedAt: string;
  /** @format date-time */
  expiresAt: string;
};

export type SandboxAssignmentDTO = {
  organizationId: string;
  workspaceId: string;
  state: 'PROVISIONING' | 'AVAILABLE' | 'ASSIGNING' | 'ASSIGNED' | 'DELETING';
  userId?: string;
  courseId?: string;
  /** @format date-time */
  assignedAt?: string;
  /** @format date-time */
  expiresAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  ssoConnection?: string;
};

export type WorkspaceDTO = {
  workspaceId: string;
  alias?: string;
  description?: string;
  tags?: string[];
  region:
    | 'us-west-2'
    | 'us-east-1'
    | 'eu-central-1'
    | 'eu-west-2'
    | 'ap-southeast-2'
    | 'ca-central-1'
    | 'us-east-2'
    | 'eu-central-2'
    | 'ap-southeast-1'
    | 'ap-northeast-1'
    | 'sa-east-1'
    | 'eu-west-1'
    | 'eu-west-3';
  /** @format date-time */
  lastUpdated: string;
  leaderFQDN: string;
  state:
    | 'Workspace-Requested'
    | 'Workspace-Provisioning'
    | 'Workspace-Provisioning-Failed'
    | 'Workspace-Provisioned'
    | 'Workspace-Active'
    | 'Workspace-Asleep'
    | 'Workspace-Asleep-Requested'
    | 'Workspace-Wake-Requested'
    | 'Workspace-Updated'
    | 'Workspace-Failed-Update'
    | 'Workspace-Cleanup-Requested'
    | 'Workspace-Cleanup-Started'
    | 'Workspace-Cleanup-Terraform-Completed'
    | 'Workspace-Cleanup-Terraform-Failed'
    | 'Workspace-Cleanup-Completed'
    | 'Workspace-Cleanup-Failed';
  releaseChannel: 'stable' | 'regular' | 'internal';
};

export type WorkspacesDTO = {
  items: WorkspaceDTO[];
  count: number;
};

/** Set the release channel. Pass null to revert to the default (regular) channel. Omit the field to leave it unchanged. */
export enum ReleaseChannel {
  Stable = 'stable',
  Regular = 'regular',
}

export type PatchWorkspaceDTO = {
  alias?: string;
  description?: string;
  tags?: string[];
  releaseChannel?: ReleaseChannel;
};

export type CreateWorkspaceDTO = {
  alias?: string;
  description?: string;
  tags?: string[];
  releaseChannel?: ReleaseChannel;
  workspaceId: string;
  /** The region for workspace provisioning. When omitted, the organization's region is used. */
  region?: string;
};
